export const MOVE_WORKFLOW_STATE = "/fund/state_movement/:memberId/";
export const GET_WORKFLOW_SUMMARY = "/workflows/summary/";
export const GET_WORKFLOW_UPDATE = "/fund/poll_state/:memberId/";
export const ADD_TO_WORKFLOW = "/workflows/enroll/";
export const GET_WORKFLOW_HISTORY = "/workflows/history/:memberId";
